import { useAppSelector } from "@store";
import { getActiveEntityId } from "@store/story/selectors";

export const useDialogTrigger = (payloadId?: string) => {
  const id = useAppSelector((state) => payloadId || getActiveEntityId(state));
  const triggerDialog = (
    type: string,
    payload: Record<string, unknown> = {},
  ) => {
    const event = new CustomEvent("trigger-angular-dialog", {
      detail: {
        type,
        payload: { ...payload, id },
      },
    });
    document.dispatchEvent(event);
  };

  return triggerDialog;
};
